import { ENV } from "../../../../src/app/interfaces/interfaces";

export const environment:ENV = {
    production: false,
    apiUrl: 'https://todotix.gateway.test.todotix.net/', //Test
    walletUrl: 'https://todotix.vouchers.test.todotix.net/', //Test
    type: 'todotix',
    title: 'Todotix',
    subtitle: 'Eventos',
    description: `"Todotix" es un sitio en el que puedes entradas a tus eventos favoritos.`,
    keywords: 'todotix, libelula, todotix entradas, entradas conciertos, conciertos, entradas, tickets',
    yearProyect: '2024',
    imgLogo: '/assets/img/logo.png',
    imgLogoSVG: '/assets/img/logo.svg',
    imgLogoWhiteSVG: '/assets/img/logo-white.svg',
    imgLogoWhite: '/assets/img/logo-white.png',

    authRedirect: '',

    // Seats IO
    region: 'sa',

    keyEncript: '12345678901234567890123456789012',
    ivEncript: '1234567890123456',

    keyRecaptcha: '6Le93p8qAAAAAJt8C4_evuUhhXwGN3esEp48i0FV',
};
